var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"quizier-module module-oembed"},[_c('div',{staticClass:"row"},[(_vm.code_preview)?_c('div',{staticClass:"col-md-12"},[_c('div',{staticClass:"initSocial",domProps:{"innerHTML":_vm._s(_vm.code_preview)}})]):_vm._e()])])}
var staticRenderFns = []

export { render, staticRenderFns }